import { apiClient, apiWrapper } from './api';
import { AuthResponse, LoginRequest, User } from '../types';

export const authService = {
  // Login
  async login(credentials: LoginRequest): Promise<AuthResponse> {
    return apiWrapper(() => apiClient.post<AuthResponse>('/auth/login', credentials));
  },

  // Refresh token (SEC-06: server now returns rotated refresh_token too)
  async refreshToken(): Promise<{ access_token: string; refresh_token?: string }> {
    return apiWrapper(() => apiClient.post<{ access_token: string; refresh_token?: string }>('/auth/refresh'));
  },

  // Get current user
  async getCurrentUser(): Promise<{ user: User; tenant: any }> {
    return apiWrapper(() => apiClient.get<{ user: User; tenant: any }>('/auth/me'));
  },

  // Change password
  async changePassword(data: { current_password: string; new_password: string }): Promise<{ message: string }> {
    return apiWrapper(() => apiClient.post<{ message: string }>('/auth/change-password', data));
  },

  // Logout
  async logout(): Promise<{ message: string }> {
    return apiWrapper(() => apiClient.post<{ message: string }>('/auth/logout'));
  },

  // Request password reset
  async requestPasswordReset(data: { email: string; tenant_key?: string }): Promise<{ message: string }> {
    return apiWrapper(() => apiClient.post<{ message: string }>('/auth/reset-password-request', data));
  },

  // BL-07: Verifizierungscode an die hinterlegte Telefonnummer senden
  async requestPhoneVerification(): Promise<{ message: string }> {
    return apiWrapper(() => apiClient.post<{ message: string }>('/auth/phone-verify/request'));
  },

  // BL-07: Telefonnummer mit dem SMS-Code bestätigen
  async confirmPhoneVerification(otp: string): Promise<{ message: string; user: User }> {
    return apiWrapper(() => apiClient.post<{ message: string; user: User }>('/auth/phone-verify/confirm', { otp }));
  },

  // BL-07: 2FA aktivieren (verifizierte Telefonnummer vorausgesetzt)
  async enable2FA(): Promise<{ message: string; user?: User }> {
    return apiWrapper(() => apiClient.post<{ message: string; user?: User }>('/auth/2fa/enable'));
  },

  // BL-07: 2FA deaktivieren – erfordert das aktuelle Passwort (401 bei falschem Passwort)
  async disable2FA(password: string): Promise<{ message: string; user?: User }> {
    return apiWrapper(() => apiClient.post<{ message: string; user?: User }>('/auth/2fa/disable', { password }));
  },

  // Verify token
  async verifyToken(): Promise<{ valid: boolean; user_id: string; claims: any }> {
    return apiWrapper(() => apiClient.get<{ valid: boolean; user_id: string; claims: any }>('/auth/verify-token'));
  },
};
